import { Button, HStack, useToast } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'

import { Loading } from '@/components'
import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { PpzAuthorizationDetail } from '@/containers/ppz-authorization/PpzAuthorizationDetail'
import { PpzAuthorizationUserInfo } from '@/containers/ppz-authorization/PpzAuthorizationUserInfo'
import { useAuth } from '@/context/AuthContext'
import { useGet, useSendEmail } from '@/hooks/usePpzAuthorization'
import { PageWrapper } from '@/layouts/components/PageWrapper'

export const PpzAuthorizationDetailPage = () => {
  const { ppzId: ppzIdParam } = useParams()
  const ppzId = Number(ppzIdParam)
  if (!ppzId)
    throw new Error('ppzId is not defined')

  const { data: ppzAuthorization, isLoading, isSuccess } = useGet(ppzId)

  const toast = useToast()
  const { mutateAsync: sendEmailAsync } = useSendEmail(ppzId)
  const sendEmail = (type: number) => sendEmailAsync(type)
    .then(() => {
      toast({
        title: 'Email byl odeslán',
        status: 'success'
      })
    })
    .catch(() => {
      toast({
        title: 'Email se nepodařilo odeslat',
        status: 'error'
      })
    })

  const { user } = useAuth()

  return (
    <PageWrapper
      header={<DashboardHeader title="Autorizace PPZ" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 6,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      {isLoading && <Loading />}
      {isSuccess && <>
        <PpzAuthorizationUserInfo userId={ppzAuthorization.ppzUserId} />

        <PpzAuthorizationDetail {...ppzAuthorization} />

        {user?.isSupervisor && import.meta.env.VITE_ENVIRONMENT !== 'production' &&
          <HStack gap={4}>
            <Button variant='link' onClick={() => sendEmail(1)}>Email vytvoření autorizace</Button>
            <Button variant='link' onClick={() => sendEmail(2)}>Email potvrzení autorizace</Button>
            <Button variant='link' onClick={() => sendEmail(3)}>Email vypršení autorizace</Button>
          </HStack>}
      </>}
    </PageWrapper>
  )
}
